<template>
    <div class="relative print:hidden z-50 top-0 left-0 w-full hidden desktop:block">
        <data id="ccaiRegion" :value="ccaiRegion()"></data>
        <!-- visible nav strip -->
        <div class="relative z-50 px-16 bg-white">
            <div class="border-b border-gray-200">
                <div class="flex justify-between text-sm">
                    <!-- left -->
                    <ul class="flex gap-2 items-center">
                        <li
                            v-for="(section, sectionIndex) in siteSections"
                            :key="sectionIndex">
                            <a
                                :href="section.url"
                                :target="target"
                                tabindex="0"
                                class="border-b-2 border-transparent py-3"
                                :class="[{
                                    'current-section border-salmon':
                                        currentSiteSection ===
                                        section.text.toLowerCase()},
                                        sectionIndex === 0 ? 'pr-2': 'px-2']
                                        ">
                                {{ section.text }}
                            </a>
                        </li>
                        <li
                            v-for="(location, locationIndex) in nearMe"
                            :key="locationIndex + siteSections.length">
                            <button
                                v-if="location.items"
                                type="button"
                                @click.prevent="updateMenu(location.items, 'left')"
                                class="flex items-center py-2 px-2 hover:text-salmon">
                                {{ location.text }}
                            </button>
                        </li>
                    </ul>

                    <!-- right -->
                    <ul class="flex gap-2 items-center">
                        <li>
                            <a :href="currentSiteSection === 'business'? '/business/search': '/search'"
                               class="text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue"
                               aria-label="Search"
                            >
                                <IconSearch class="w-10 h-10 px-3.25 py-3.25" />
                            </a>
                        </li>

<!--                        <li>-->
<!--                            <a-->
<!--                                v-if="phoneNumber && currentSiteSection === 'business'"-->
<!--                                class="flex items-center pr-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue"-->
<!--                                :href="'tel:' + (isCarrierPage ? carrierPageNumber : phoneNumber)"-->
<!--                            >-->
<!--                                <IconPhone class="w-10 h-10 px-2 py-3.25" />-->
<!--                                {{ isCarrierPage ? carrierPageNumber : phoneNumber }}-->
<!--                            </a>-->
<!--                        </li>-->

                        <li v-if="showLanguageSwitcher">
                           <select class="hover:border-none border-none text-sm py-2 pl-2 pr-4 bg-right cursor-pointer hover:text-salmon" @change="changeLanguage" aria-label="Language Switcher">
                               <option value="/es.>/www." :selected="!onSpanishSite">EN</option>
                               <option value="/www.>/es." :selected="onSpanishSite">ES</option>
                           </select>
                        </li>
                        <li v-for="(tool, toolIndex) in userTools" :key="toolIndex">
                            <div v-if="tool.items"
                                 class="flex gap-2 items-center">
                                <button
                                    type="button"
                                    @click.prevent="updateMenu(tool.items, 'right')"
                                    class="flex items-center hover:text-salmon py-2"
                                    :class="toolIndex === userTools.length - 1 ? 'pl-2': 'px-2'"
                                    v-html="tool.text">
                                </button>
                            </div>
                            <a  v-else
                                :href="tool.url"
                                :target="target"
                                class="flex gap-2 items-center py-2"
                                :class="toolIndex === userTools.length - 1 ? 'pl-2': 'px-2'"
                                v-html="tool.text">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- tint/overlay -->
        <transition name="fade">
            <div
                v-show="rightMenuIsVisible || leftMenuIsVisible"
                class="bg-white fixed h-full inset-0 opacity-75 w-full z-40"
                @click.prevent="toggleMenuVisibility()"
            ></div>
        </transition>

        <!-- sliding my account menu -->
        <transition name="slide-down">
            <div
                v-show="leftMenuIsVisible"
                :class="menuClass"
                class="absolute bg-white flex flex-col items-center js-submenu justify-start px-16 py-8 h-screen top-0 shadow z-50 overflow-y-scroll overflow-x-hidden">               <div
                    :class="menuGridColumnsClass"
                    class="auto-cols-fr container grid">
                    <div
                        v-for="(item, itemIndex) in menuItems"
                        :key="itemIndex">
                        <a
                            :href="item.url"
                            class="inline-block text-center font-heavy">
                            {{ item.text }}
                        </a>

                        <div class="font-bold mb-2">
                            {{ item.itemsHeading }}
                        </div>
                        <ul>
                            <li
                                v-for="(subItem, subItemIndex) in item.items"
                                :key="subItemIndex"
                                class="mb-2">
                                <a
                                    :href="subItem.url"
                                    :target="subItem.target ? '_blank' : ''"
                                    class="text-sm">
                                    {{ subItem.text }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </transition>

        <!-- right menu: sliding my account menu -->

        <transition name="slide-left">
            <div
                v-show="rightMenuIsVisible"
                :class="menuClass"
                class="absolute bg-white flex flex-col gap-12 items-center js-submenu justify-start p-6 h-screen top-0 shadow z-50 overflow-scroll w-88">
                <button @click.prevent="hideSlider()" class="self-end">
                    <IconXmark class="text-lg" />
                </button>
                <!-- logo and cta -->
                <div
                    v-if="menuItems && !selectedSubmenu"
                    class="w-full flex flex-col items-center gap-8 mt-12">
                    <div class="desktop:w-48">
                        <AppLogo :logo-link="logoLink" :target="target" />
                    </div>
                    <a
                        :href="currentSiteSection === 'business'? '/business/online-account-manager':'https://myaccount.breezeline.com/'"
                        target=""
                        class="btn-primary w-full text-center current-section">
                        Sign in
                    </a>
                </div>

                <!-- first menu -->
                <transition name="slide-in-place">
                    <div
                        v-if="menuItems && !selectedSubmenu"
                        :class="menuGridColumnsClass"
                        class="auto-cols-fr container grid">
                        <div>
                            <div
                                v-for="(item, itemIndex) in menuItems"
                                :key="itemIndex">
                                <!-- Type: Group -->
                                <template v-if="item.type === 'group'">
                                    <div class="mb-12">
                                        <div
                                            v-for="(menuItem, menuItemIndex) in item.items"
                                            :key="menuItemIndex"
                                            :class="dividerClass(menuItem)">
                                            <!-- Has Submenu Items -->
                                            <div v-if="menuItem.items && menuItem.items.length > 0">
                                                <div @click.stop="selectSubmenu(menuItem)">
                                                    <!-- Has Icon -->
                                                    <div
                                                        v-if="menuItem.icon"
                                                        class="py-4 flex gap-2 items-center">
                                                        <img
                                                            :src="menuItem.icon"
                                                            width="20"
                                                            alt="" />
                                                        <a
                                                            :href="menuItem.url"
                                                            :target="menuItem.target"
                                                            class="w-full flex justify-between items-center text-center text-navy-dark font-semibold">
                                                            {{ menuItem.text }}
                                                        </a>
                                                        <span v-if="menuItem.items">
                                                            <IconChevronRight />
                                                        </span>
                                                    </div>
                                                    <!-- Has Divider -->
                                                    <div v-else-if="menuItem && !menuItem.icon && menuItem.text">
                                                        <div class="flex items-center justify-between py-4">
                                                            <a :href="menuItem.url"
                                                                :target="menuItem.target"
                                                                class="w-full flex justify-between items-center text-center text-navy-dark font-semibold">
                                                                {{ menuItem.text }}
                                                            </a>
                                                            <span v-if="menuItem.items">
                                                                <IconChevronRight />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- No Submenu Items, open href link -->
                                            <div v-else>
                                                <div
                                                    v-if="menuItem.icon"
                                                    class="py-4 flex gap-2 items-center">
                                                    <img :src="menuItem.icon" width="20" alt="" />
                                                    <a :href="menuItem.url"
                                                        :target="menuItem.target"
                                                        class="w-full flex justify-between items-center text-center text-navy-dark font-semibold">
                                                        {{ menuItem.text }}
                                                    </a>
                                                    <span v-if="menuItem.items">
                                                        <IconChevronRight />
                                                    </span>
                                                </div>
                                                <div v-else-if="menuItem && !menuItem.icon && menuItem.text">
                                                    <div class="flex items-center justify-between py-4">
                                                        <a :href="menuItem.url"
                                                            :target="menuItem.target"
                                                            class="w-full flex justify-between items-center text-center text-navy-dark font-semibold">
                                                            {{ menuItem.text }}
                                                        </a>
                                                        <span v-if="menuItem.items">
                                                            <IconChevronRight />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!-- Type: Link -->
                                <template v-else>
                                    <div :class="dividerClass(item)">
                                        <div v-if="item.items && item.items.length > 0">
                                            <!-- Submenu items exist -->
                                            <div @click.stop="selectSubmenu(item)">
                                                <div
                                                    v-for="(menuItem, menuItemIndex) in item.items"
                                                    :key="menuItemIndex">
                                                    <!-- Has icon -->
                                                    <div
                                                        v-if="menuItem.icon"
                                                        class="py-4 flex gap-2 items-center">
                                                        <img
                                                            :src="menuItem.icon"
                                                            width="20"
                                                            alt="" />
                                                        <a
                                                            :href="menuItem.url"
                                                            :target="menuItem.target"
                                                            class="w-full flex justify-between items-center text-center text-navy-dark font-semibold">
                                                            {{ menuItem.text }}
                                                        </a>
                                                        <span v-if="menuItem.items">
                                                            <IconChevronRight />
                                                        </span>
                                                    </div>
                                                    <!-- Has divider -->
                                                    <div v-else
                                                        class="py-4 flex justify-between items-center">
                                                        <div
                                                            class="w-full flex justify-between items-center text-center text-navy-dark font-semibold">
                                                            {{ item.text }}
                                                        </div>
                                                        <span v-if="item.items">
                                                            <IconChevronRight />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- No submenu items, open href link -->
                                        <div v-else
                                            class="py-4">
                                            <div
                                                v-if="item.icon"
                                                class="flex gap-2 items-center">
                                                <img
                                                    :src="item.icon"
                                                    width="20"
                                                    alt="" />
                                                <a
                                                    :href="item.url"
                                                    :target="item.target"
                                                    class="w-full flex justify-between items-center text-center text-navy-dark font-semibold">
                                                    {{ item.text }}
                                                </a>
                                                <span v-if="item.items">
                                                    <IconChevronRight />
                                                </span>
                                            </div>
                                            <a v-else
                                                :href="item.url"
                                                :target="item.target"
                                                class="w-full flex justify-between items-center text-center text-navy-dark font-semibold">
                                                {{ item.text }}
                                            </a>
                                        </div>
                                    </div>
                                </template>

                                <div class="font-bold">
                                    {{ item.itemsHeading }}
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- submenu (dynamic) -->
                <transition name="slide-in-place">
                    <div v-if="menuItems && selectedSubmenu" class="w-full">

                        <!-- parent menu / go back -->
                        <button
                            @click.prevent="selectedSubmenu = null"
                            class="relative flex justify-between items-center w-full py-3 z-40 border-b border-gray-200">
                            <IconChevronLeft />
                            <div class="font-bold text-xl">
                                {{ selectedSubmenu.text }}
                            </div>
                            <span><!-- empty --></span>
                        </button>

                        <div
                            v-if="selectedSubmenu && selectedSubmenu.text === 'Support'"
                            class="my-6">

                            <!-- submenu search -->
                            <span class="font-bold text-xl">Support Search</span>
                            <form
                                target="_blank"
                                action="https://breezeline.com/search">
                                <input
                                    type="search"
                                    name="search"
                                    id="search"
                                    placeholder="Search..."
                                    aria-label="Search field"
                                    class="w-full rounded border-0 mt-4 py-4 pl-8 text-lg text-black shadow"/>
                            </form>

                            <div v-for="(menuItem, menuItemIndex) in selectedSubmenu.items"
                                :key="menuItemIndex"
                                :class="dividerClass(menuItem)">

                                <!-- submenu items -->
                                <div class="mt-12">
                                    <h4 v-if="menuItem.text"
                                        class="text-lg mt-12">{{ menuItem.text }}</h4>
                                    <ul>
                                        <li v-for="(menuItemGroup, menuItemGroupIndex) in menuItem.items"
                                            :key="menuItemGroupIndex"
                                            :class="dividerClass(menuItemGroup)"
                                            class="py-4">
                                            <div
                                                v-if="menuItemGroup.icon"
                                                class="py-4 flex gap-2 items-center">
                                                <img
                                                    :src="menuItemGroup.icon"
                                                    width="20"
                                                    alt="" />
                                                <a
                                                    :href="menuItemGroup.url"
                                                    :target="menuItemGroup.target"
                                                    class="w-full flex justify-between items-center text-center text-navy-dark font-semibold">
                                                    {{ menuItemGroup.text }}
                                                </a>
                                                <span v-if="menuItemGroup.items">
                                                    <IconChevronRight />
                                                </span>
                                            </div>
                                            <a v-else
                                                :href="menuItemGroup.url"
                                                :target="menuItemGroup.target ? '_blank' : ''"
                                                class="text-navy-dark">
                                                {{ menuItemGroup.text }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import IconChevronDown from "@/atoms/icons/IconChevronDown";
import AppLogo from "../../atoms/AppLogo/appLogo.vue";
import IconChevronRight from "@/atoms/icons/IconChevronRight";
import IconChevronLeft from "@/atoms/icons/IconChevronLeft";
import IconXmark from "@/atoms/icons/IconXmark";
import IconSearch from "../../atoms/icons/IconSearch.vue";
import IconPhone from "../../atoms/icons/IconPhone.vue";

export default {
    name: "AppNavBar",
    components: {
		IconPhone,
		IconSearch,
        IconChevronDown,
        IconChevronRight,
        IconChevronLeft,
        AppLogo,
        IconXmark,
    },
    props: {
        siteSections: {
            type: Array,
            default: () => [],
        },
        userTools: {
            type: Array,
            default: () => [],
        },
        nearMe: {
            type: Array,
            default: () => [],
        },
		phoneNumber: {
			type: String,
			required: false,
		},
        currentSiteSection: {
            type: String,
            default: () => [],
        },
        userLocation: {
            type: String,
            default: () => [],
        },
        includeLocation: {
            type: Boolean,
            default: () => [],
        },
        logoLink: {
            type: String,
            default: () => [],
        },
        target: {
            type: String,
            default: () => [],
        },
		isCarrierPage: {
			type: Boolean,
		},
		carrierPageNumber: {
			type: String,
			required: false,
		}
    },
    data: () => ({
        menuItems: [],
        rightMenuIsVisible: false,
        leftMenuIsVisible: false,
        menuClass: "",
        menuGridColumnsClass: "",
        selectedSubmenu: "",
    }),
    computed: {
        ...mapState([
            'meta',
        ]),
        showLanguageSwitcher() {
            return this.currentSiteSection === "residential";
        },
        dividerClass() {
            return (item, menuItem, menuItemGroup) => {
                if (item && !item.icon && item.text || menuItem && !menuItem.icon && menuItem.text || (menuItemGroup && !menuItemGroup.icon && menuItemGroup.text)) {
                    return 'border-b border-gray-200 last:border-b-0';
                } else {
                    return '';
                }
            }
        },
		onSpanishSite() {
            return window.location.href.indexOf('/es.') > -1;
		},
    },
    methods: {
        // changeLanguage takes a from and to value and replaces the value in the current url and changes the from value to the to value
        // This is used to replace the es.breezeline.com start of the bzl url with www.breezeline.com
		changeLanguage(event) {
            const fromTo = event.target.value.split('>');
            window.location.href =  window.location.href.replace(fromTo[0], fromTo[1]);
        },
        launchSwitcher() {
            let script = document.createElement("SCRIPT");
            script.src =
                "https://breezeline.mpeasylink.com/mpel/mpel_chooser.js";
            document.body.appendChild(script);
            window.scroll({ top: 0, left: 0, behavior: "smooth" });
            return false;
        },
        updateMenu(items, direction) {
            this.menuClass =
                direction === "right"
                    ? "desktop:right-0"
                    : "desktop:left-0 pr-32";
            this.menuGridColumnsClass =
                direction === "right"
                    ? "desktop:grid-cols-1"
                    : "desktop:grid-cols-2 gap-y-8 gap-x-32";
            if (this.menuItems == items) {
                this.toggleMenuVisibility(direction);
            } else {
                this.menuItems = items;
                if (!this.rightMenuIsVisible && !this.leftMenuIsVisible) {
                    this.toggleMenuVisibility(direction);
                }
            }
        },
        toggleMenuVisibility(direction = "") {
            if (this.rightMenuIsVisible || this.leftMenuIsVisible) {
                removeEventListener("focusin", this.checkFocus);
                removeEventListener("keyup", this.closeIfEsc);
                this.rightMenuIsVisible = false;
                this.leftMenuIsVisible = false;
                this.$emit("overlay-closed");
            } else if (direction === "right") {
                addEventListener("focusin", this.checkFocus);
                addEventListener("keyup", this.closeIfEsc);
                this.rightMenuIsVisible = true;
                this.$emit("overlay-opened");
            } else if (direction === "left") {
                addEventListener("focusin", this.checkFocus);
                addEventListener("keyup", this.closeIfEsc);
                this.leftMenuIsVisible = true;
                this.$emit("overlay-opened");
            }
        },
        closeIfEsc(evt) {
            if (evt.key === "Escape") {
                this.toggleMenuVisibility();
            }
        },
        checkFocus(evt) {
            const navItems = [...this.$el.querySelectorAll(".js-submenu")];
            if (!navItems.some((e) => e.contains(evt.target))) {
                this.toggleMenuVisibility();
            }
        },
        hideSlider() {
            this.rightMenuIsVisible = false;
            this.$emit("overlay-closed");
        },
        selectSubmenu(item) {
            if (item.items && item.items.length > 0) {
                // Handle submenu item selection
                this.selectedSubmenu = item;
            } else {
                // Handle regular menu item selection
                console.log('Menu item selected:', item);
            }
        },
        ccaiRegion() {
            return this.meta.stateOrProvince
        }
    },
};
</script>

<style lang="scss" scoped>
a:not(.current-section) {
    @apply hover:text-salmon;
}
input[type="search"] {
    background-position: right 1.5em top 50% !important;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.2939 12.5786H13.3905L13.0703 12.2699C14.191 10.9663 14.8656 9.27387 14.8656 7.43282C14.8656 3.32762 11.538 0 7.43282 0C3.32762 0 0 3.32762 0 7.43282C0 11.538 3.32762 14.8656 7.43282 14.8656C9.27387 14.8656 10.9663 14.191 12.2699 13.0703L12.5786 13.3905V14.2939L18.2962 20L20 18.2962L14.2939 12.5786V12.5786ZM7.43282 12.5786C4.58548 12.5786 2.28702 10.2802 2.28702 7.43282C2.28702 4.58548 4.58548 2.28702 7.43282 2.28702C10.2802 2.28702 12.5786 4.58548 12.5786 7.43282C12.5786 10.2802 10.2802 12.5786 7.43282 12.5786Z' fill='%23001E62'/%3E%3C/svg%3E%0A") !important;
}
</style>
